import * as React from "react";
const SvgFiRrLightbulbSetting = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-lightbulb-setting_svg__a)">
      <path
        fill="#062147"
        d="M9 20H6.998l.002.31c0 .932.758 1.69 1.69 1.69H10a1 1 0 0 1 0 2H8.69A3.694 3.694 0 0 1 5 20.31v-.16c0-1.667-.757-3.289-2.132-4.568-2.15-1.999-3.166-4.828-2.793-7.76C.59 3.782 3.904.517 7.955.06c4.452-.504 8.65 2.374 9.762 6.692a1 1 0 0 1-.72 1.217 1 1 0 0 1-1.218-.719c-.877-3.413-4.076-5.6-7.6-5.203-3.146.355-5.72 2.891-6.12 6.03-.292 2.284.5 4.487 2.17 6.042 1.2 1.117 2.038 2.451 2.458 3.881h1.312v-7.172a3 3 0 0 1-2-2.828 1 1 0 0 1 2 0 1.001 1.001 0 0 0 2 0 1.001 1.001 0 0 1 2 0 3 3 0 0 1-2 2.828V19a1 1 0 0 1-1 1zm14.562.5a1 1 0 0 1-1.366.366l-.956-.552A5 5 0 0 1 18.5 21.9V23a1 1 0 1 1-2 0v-1.1a5 5 0 0 1-2.74-1.586l-.956.552a.997.997 0 0 1-1.366-.366 1 1 0 0 1 .366-1.366l.953-.55a4.992 4.992 0 0 1 0-3.166l-.953-.55a1 1 0 0 1 1-1.732l.956.552a5 5 0 0 1 2.74-1.585v-1.1a1 1 0 1 1 2 0v1.1a5 5 0 0 1 2.74 1.585l.956-.552a1 1 0 0 1 1 1.732l-.953.55a4.992 4.992 0 0 1 0 3.166l.953.55a1 1 0 0 1 .366 1.366M20.5 17c0-1.654-1.346-3-3-3s-3 1.346-3 3 1.346 3 3 3 3-1.346 3-3"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-lightbulb-setting_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLightbulbSetting;
